// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"46":"b2c16095","999":"b2c16095"}[chunkId] + ".chunk.css";
};